import { render, staticRenderFns } from "./buyerManage.vue?vue&type=template&id=ec85ec50&scoped=true&"
import script from "./buyerManage.vue?vue&type=script&lang=js&"
export * from "./buyerManage.vue?vue&type=script&lang=js&"
import style0 from "./buyerManage.vue?vue&type=style&index=0&id=ec85ec50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec85ec50",
  null
  
)

export default component.exports